import { ReactNode } from 'react'
import { FormGroup, Modal } from 'react-bootstrap'
import FormHandler from '../../../utils/Form/FormHandler'
import Field from '../../../utils/Form/Widgets/Field'
import AutocompleteSelect from '../../../utils/Form/Widgets/AutocompleteSelect'
import Check from '../../../utils/Form/Widgets/Check'

type Props = {
  onHide: () => void
  show: boolean
  itemIdForUpdate?: string
  refreshFunction?: Function
}
class ImportFileTemplate {
  title?: string
  header_row_exist?: boolean
  header_row_index?: number
  meter_id_column?: number
  date_column?: number
  date_format?: string
  data_start_column?: number
}
class ImportFileTemplateEditModal extends FormHandler {
  constructor(props: Props) {
    super(props)
    this.state = { entity: new ImportFileTemplate() }
  }

  getApiUrl(): string {
    return '/import_file_structure_template/save/' + this.props.itemIdForUpdate
  }
  getSingleUrl() {
    if (this.props.itemIdForUpdate === 'add') {
      return null
    } else {
      return '/import_file_structure_template/single/' + this.props.itemIdForUpdate
    }
  }

  getPostData(): object {
    return {
      import_file_structure_template: this.state.entity,
    }
  }
  render(): ReactNode {
    var state = this.state as any

    return (
      <Modal
        id='kt_modal_create_company'
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        size='lg'
        show={this.props.show}
        backdrop={true}
        onHide={this.props.onHide}
      >
        <form
          onSubmit={(event) => {
            this.handleSubmit(event).then((response) => {
              if (this.props.refreshFunction) {
                this.props.refreshFunction(response.data.data.entity_id)
              }
            })
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {this.props.itemIdForUpdate === 'add' ? 'Add' : 'Edit'} Import File Template
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <Field
                title='Title'
                className='form-control'
                type='text'
                name='title'
                onInput={(event: any) => {
                  this.handleInputChange(event)
                }}
                value={state.entity.title}
              />
              <Check
                title='Header Row Exist'
                type='checkbox'
                name='header_row_exist'
                onChange={(event: any) => {
                  this.handleInputChange(event)
                }}
                checked={state.entity.header_row_exist}
                options={['']}
              />
              {state.entity.header_row_exist && (
                <div className='mb-3'>
                  <Field
                    title='Header Row Index'
                    className='form-control'
                    type='number'
                    name='header_row_index'
                    onChange={(event: any) => this.handleInputChange(event)}
                    value={state.entity.header_row_index ?? 1}
                  />
                  <div className='form-text'>
                    Index starts from 1. If you have a header in the fifth row, enter 5. For the
                    first row, enter 1.
                  </div>
                </div>
              )}

              <Field
                title='Meter Id Column'
                className='form-control'
                type='number'
                name='meter_id_column'
                onInput={(event: any) => {
                  this.handleInputChange(event)
                }}
                value={state.entity.meter_id_column}
              />
              <div className='form-text'>
                Index starts from 0. If you have a meter id in the third column, enter 2.
              </div>
              <Field
                title='Date Column'
                className='form-control'
                type='number'
                name='date_column'
                onInput={(event: any) => {
                  this.handleInputChange(event)
                }}
                value={state.entity.date_column}
              />
              <div className='form-text'>
                Index starts from 0. If you have a date in the fourth column, enter 3.
              </div>
              <Field
                title='Date Format'
                className='form-control'
                type='text'
                name='date_format'
                onInput={(event: any) => {
                  this.handleInputChange(event)
                }}
                value={state.entity.date_format}
              />
              <Field
                title='Data Start Column'
                className='form-control'
                type='number'
                name='data_start_column'
                onInput={(event: any) => {
                  this.handleInputChange(event)
                }}
                value={state.entity.data_start_column}
              />
              <div className='form-text'>
                Index starts from 0. If you have data in the fifth column, enter 4.
              </div>
            </FormGroup>
          </Modal.Body>
          <Modal.Footer className='justify-content-end'>
            {this.props.itemIdForUpdate !== 'add' ? (
              <button
                type='button'
                onClick={(event) => {
                  this.handleDelete(event).then((response) => {
                    if (this.props.refreshFunction) {
                      this.props.refreshFunction('')
                    }
                  })
                }}
                className='btn btn-danger btn-sm'
              >
                <span className='fa fa-trash'></span>
                Delete
              </button>
            ) : (
              <></>
            )}
            <button type='submit' className='btn btn-success btn-sm'>
              <span className='fa fa-floppy-save'></span>
              Save
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export { ImportFileTemplateEditModal }
